import { Injectable } from '@angular/core';
import { AppProperty, Settings } from '../ridango.models';

// https://juristr.com/blog/2018/01/ng-app-runtime-config/
@Injectable({
    providedIn: 'root',
})
export class AppConfigService {
    static appConfig: Settings;

    getConfig(): Settings {
        return AppConfigService.appConfig;
    }

    getAppProperty(regionId: string): AppProperty {
        return AppConfigService.appConfig.APP_PROPERTY[regionId];
    }
}
